<template>
  <b-col class="puriifer">
  <router-link :to="purifier.detailPage()">
    <h2>{{ purifier.name }}</h2>
    <purifier-image :purifier="purifier"></purifier-image>
    <button>Learn More</button>
  </router-link>
  </b-col>
</template>

<script>
import PurifierImage from '@/components/PurifierImage'

export default {
  components: {PurifierImage},
  name: 'PurifierView',
  props: {
    purifier: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
  margin-bottom:0;
}
a h1, a h2, a:hover {
  text-decoration:none;
  color: #2c3e50;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
button {
  color:#355197;
  border-radius:20px;
  border-color:#355197;
  font-size:90%;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PurifierView.vue